export default __webpack_public_path__ + "ef33f684e129adcfca670657fe3f4e6f.png";